import { render } from "./DialogConfirmFirstTimeToChangePurchasedTicket.vue?vue&type=template&id=5388fd35"
import script from "./DialogConfirmFirstTimeToChangePurchasedTicket.vue?vue&type=script&lang=js"
export * from "./DialogConfirmFirstTimeToChangePurchasedTicket.vue?vue&type=script&lang=js"
script.render = render

export default script